import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./styles.css";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { useAuthStore } from "./state/auth";
import { LanguageProvider } from "./i18n";
import { applyTheme, loadStoredTheme } from "./lib/theme";

// Apply the saved theme before React paints to avoid a light→dark flash.
applyTheme(loadStoredTheme());

console.log("🚀 App starting...", window.location.href);

// Kick off auth session restoration immediately, before React renders.
// This ensures ProtectedRoute sees loading=true until refresh() finishes.
useAuthStore.getState().refresh();

const root = document.getElementById("root");

if (!root) {
  console.error("❌ Root element not found");
  throw new Error("Root element not found");
}

console.log("✅ Root element found, rendering app");

const queryClient = new QueryClient();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

registerServiceWorker();
